import { render, staticRenderFns } from "./title.vue?vue&type=template&id=080b049b&scoped=true"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"
import style0 from "./title.vue?vue&type=style&index=0&id=080b049b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b049b",
  null
  
)

export default component.exports